import actionTypes from 'constants/actionTypes'
import type { PreviousNeighborhoodsMap, PreviousNeighborhoodSnapshot } from 'types/domain'

interface PreviousNeighborhoodsAction {
  type?: string
  payload?: {
    capturedAtMs?: number | string
  } & PreviousNeighborhoodSnapshot
}


const previousNeighborhoods = (state: PreviousNeighborhoodsMap = {}, action: PreviousNeighborhoodsAction): PreviousNeighborhoodsMap => {
  switch (action.type) {
    case actionTypes.GRAPH.PREVIOUS_NEIGHBORHOODS.CAPTURE: {
      const capturedAtMs = action.payload?.capturedAtMs
      if (capturedAtMs == null) return state
      const nextState = Object.assign({}, state)
      nextState[String(capturedAtMs)] = action.payload as PreviousNeighborhoodSnapshot
      return nextState
    }
    case actionTypes.GRAPH.PREVIOUS_NEIGHBORHOODS.REMOVE: {
      const capturedAtMs = action.payload?.capturedAtMs
      if (capturedAtMs == null) return state
      const key = String(capturedAtMs)
      if (state[key] == null) return state
      const nextState = Object.assign({}, state)
      delete nextState[key]
      return nextState
    }
    default:
      return state
  }
}

export default previousNeighborhoods
